"use strict";

module.exports = function () {
	$(document).on("click", "[js-navigating-pages-btn]", function() {
		var wrap = $(this).closest("[js-navigating-pages]"),
			field = wrap.find($("[js-navigating-pages-field]")),
			fieldVal = +(field.val())-1,
			quantityPages = $(".data-tables").DataTable().page.info();

		if(fieldVal > quantityPages["pages"]) {
			$(".data-tables").DataTable().page("last").draw("page");
		} else {
			$(".data-tables").DataTable().page(fieldVal).draw("page");
		}
	});



	$(document).on("keydown", "[js-navigating-pages-field]",  function(e) {
		var wrap = $(this).closest("[js-navigating-pages]"),
			btn  = wrap.find($("[js-navigating-pages-btn]"));

		if(e.keyCode == 13) {
			btn.trigger("click");
			e.preventDefault();
			return false;
		}
	});
};